import { Component } from 'react';
import MDCCard, {
	CardPrimaryContent,
	CardMedia,
	CardActions,
	CardActionButtons,
	CardActionIcons,
} from '@material/react-card';
import PropTypes from 'prop-types';

import classes from './Card.module.scss';
const STYLE_DEFAULT = 'mdc-card';
const STYLE_SMALL = 'mdc-card--small';
const STYLE_MEDIUM = 'mdc-card--medium';
const STYLE_LARGE = 'mdc-card--large';
const STYLE_XLARGE = 'mdc-card--xlarge';
const STYLE_SUBMITTED = 'mdc-card__submitted';
const STYLE_ACTIVE = 'mcd-card__active';
const STYLE_MESSAGE = 'mdc-card__message';
const STYLE_MESSAGETYPE_ERROR = 'mdc-card__message--error';
const STYLE_MESSAGETYPE_WARNING = 'mdc-card__message--warning';
const STYLE_MESSAGETYPE_INFORMATION = 'mdc-card__message--information';
const STYLE_MESSAGETYPE_SUCCESS = 'mdc-card__message--success';

class Card extends Component {
	render() {
		let style = null;
		if (this.props.small) {
			style = STYLE_SMALL;
		}
		if (this.props.medium) {
			style = STYLE_MEDIUM;
		}
		if (this.props.large) {
			style = STYLE_LARGE;
		}
		if (this.props.xlarge) {
			style = STYLE_XLARGE;
		}

		let isSubmittedStyle = this.props.submitted
			? STYLE_SUBMITTED
			: STYLE_ACTIVE;

		let isMessageStyle = null;
		let isMessageTypeStyle = null;
		if (this.props.message) {
			isMessageStyle = STYLE_MESSAGE;
			switch (this.props.type) {
				case 'Error':
				case 'Critical':
					isMessageTypeStyle = STYLE_MESSAGETYPE_ERROR;
					break;
				case 'Warning':
					isMessageTypeStyle = STYLE_MESSAGETYPE_WARNING;
					break;
				case 'Information':
				case 'Info':
					isMessageTypeStyle = STYLE_MESSAGETYPE_INFORMATION;
					break;
				case 'Success':
					isMessageTypeStyle = STYLE_MESSAGETYPE_SUCCESS;
					break;
				default:
					isMessageTypeStyle = null;
			}
		}

		return (
			<MDCCard
				className={[
					this.props.className,
					classes[STYLE_DEFAULT],
					classes[style],
					classes[isSubmittedStyle],
					classes[isMessageStyle],
					classes[isMessageTypeStyle],
				].join(' ')}
				id={this.props.id}
				outlined={this.props.outlined}
				style={this.props.style}
				data-test={this.props['data-test']}
			>
				{this.props.children}
			</MDCCard>
		);
	}
}

const isSized = (props, propName, componentName) => {
	const SMALL = 'small';
	const MEDIUM = 'medium';
	const LARGE = 'large';
	const XLARGE = 'xlarge';

	if (
		!props.hasOwnProperty(SMALL) &&
		!props.hasOwnProperty(MEDIUM) &&
		!props.hasOwnProperty(LARGE) &&
		!props.hasOwnProperty(XLARGE)
	) {
		return new Error(
			'Failed prop type: The prop `' +
				SMALL +
				'`, prop `' +
				MEDIUM +
				'`, prop `' +
				LARGE +
				'` OR prop `' +
				XLARGE +
				'` is marked as required in `' +
				componentName +
				'`, but its value is `undefined`.'
		);
	} else {
		if (props.hasOwnProperty(propName)) {
			const type = typeof props[propName];
			if (!(type === 'boolean')) {
				return new Error(
					'Failed prop type: Invalid prop `' +
						propName +
						'` of type `' +
						type +
						'` supplied to `' +
						componentName +
						'`, expected `bool`.'
				);
			}
		}
	}

	return;
};

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/card#props
Card.propTypes = {
	className: PropTypes.string,
	large: isSized,
	medium: isSized,
	outlined: PropTypes.bool,
	small: isSized,
	style: PropTypes.object,
	xlarge: isSized,
};

export {
	CardPrimaryContent as PrimaryContent,
	CardMedia as Media,
	CardActions as Actions,
	CardActionButtons as ActionButtons,
	CardActionIcons as ActionIcons,
};
export default Card;
